import React, { useState } from 'react';
import Button from '../../../../../component/ui/Button';
import Modal from '../../../../../component/modal/Modal';
import { deleteParentAccount } from '../../../../../services/settings/accounting';
import { toast } from 'react-toastify';

export default function DeleteParentAccountModal({
	isOpenModal,
	setIsOpenModal,
	parentAccountId,
	getList,
}) {
	const [loader, setLoader] = useState(false);
	const handleDeactivateParentAccount = async () => {
		try {
			setLoader(true);
			const res = await deleteParentAccount(parentAccountId);
			if (res.success) {
				toast.success(res.message);
				setIsOpenModal(false);
				getList();
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};
	return (
		<Modal
			className="confirmatinBoxModal"
			title={'Are You Sure?'}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div
				className="fs-4 fw-semibold text-center px-6 py-3"
				style={{ color: '#979797' }}
			>
				This parent account will no longer be available for new child account mappings, but existing
				account relationships and reports will remain unchanged.
			</div>
			<div className="d-flex align-items-center justify-content-center mt-4 gap-4">
				<Button
					type="button"
					button={`Cancel`}
					dataTestId={'parent-account-cancel-button'}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
				<Button
					type="button"
					disabled={loader}
					loader={loader}
					button={`Confirm`}
					dataTestId={'parent-account-confirm-button'}
					className="mt-0 px-4 btn-primary relative"
					onClick={() => handleDeactivateParentAccount()}
				/>
			</div>
		</Modal>
	);
}
